<template>
  <UploadLi
    :icon="phoneImg"
    nameText=""
    nameTip=""
    @upload="upload"
    v-bind="$attrs"
  />
</template>

<script>
import phoneImg from '@/assets/images/phone.png';
import UploadLi from './UploadLi.vue';

export default {
  name: 'PhoneUpload',
  components: {
    UploadLi,
  },
  props: {
    isUpload: {
      type: Boolean,
    },
  },
  data() {
    return {
      phoneImg,
    };
  },
  methods: {
    // 跳转RPA
    async upload() {
      if (!this.isUpload) {
        this.$toast('该产品不支持“手机上传“，请选择“电脑上传”');
        return;
      }
      const {
        orderId, taxNo, name, identity, corpName,
      } = this.$route.query;
      console.log({
        jumpUrl: window.location.href,
        orderId,
        taxNo,
        name,
        identity,
        corpName,
      });
      const { returnCode, data, returnMessage } = await this.$api.PublicPage.getRpaUrl({
        jumpUrl: window.location.href+'&back=1',
        orderId,
        taxNo,
        name,
        identity,
        corpName,
      });
      if (returnCode === '200') {
        window.location.href = data.url;
      } else {
        this.$toast(returnMessage || '跳转手机上传页面失败，请稍后重试');
      }
    },
  },
};
</script>
<style scoped lang="scss">
</style>
